/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ActorRoleId } from "../../commons/types/ActorRoleId";
import { RoleId } from "../../commons/types/RoleId";
import { ActorIdUnion } from "../../commons/types/ActorIdUnion";
import { ResourceIdUnion } from "./ResourceIdUnion";
export const ActorRoleResponse = core.serialization.object({
    id: ActorRoleId,
    roleId: RoleId,
    actorId: ActorIdUnion,
    resourceId: ResourceIdUnion,
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
});
